module.exports = __webpack_public_path__ + "static/media/JPEG0.5.4e11cf39.jpg";